import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../../../components/Flex";
import StyledButtonV2 from "../../../../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import { ExamCheckboxSection } from "../../InitialPsychotherapy/InitialPsychotherapyConstant";
import CheckboxCardSections from "../../InitialPsychotherapy/CheckboxCardSections";

interface BirpCheckboxModalProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
  title: string;
  sections: ExamCheckboxSection[];
  /** Field paths this modal owns; only these are written back on Save. */
  fields: string[];
}

/**
 * Multiselect modal shared by the four BIRP checkbox sections (Therapeutic
 * Interventions, Topics Addressed, Patient Participation and Response to
 * Intervention). Same components, storage shape and draft-until-Save behavior
 * as the Psychotherapy Note MSE modal — only the option list differs.
 */
const BirpCheckboxModal = ({
  disclosureHost,
  formik,
  title,
  sections,
  fields,
}: BirpCheckboxModalProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in.
  const draft = useFormDraft(formik, fields, disclosureHost.opened);

  const handleSave = () => {
    draft.save();
    disclosureHost.close();
  };

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle={title}
      dialogAction={
        <>
          <StyledButtonV2
            label="Cancel"
            variant="outlined"
            onClick={() => disclosureHost.close()}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={handleSave}
            sx={{ width: "105px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "60vw",
          height: "80vh",
        },
      }}
    >
      <Flex flexDirection="column" gap={2} width="100%" height="100%" pt={2}>
        <CheckboxCardSections formik={draft} sections={sections} />
      </Flex>
    </StyledFormModal>
  );
};

export default BirpCheckboxModal;
